/**
 * BASE ADMIN
 * https://komutteknolojisi.com
 *
 * @author Goncanur Uz <goncanur@komutteknolojisi.com>
 * @format
 * @flow strict-local
 */

import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import rootReducers from "./reducers";
import rootSaga from "./sagas";

//SAGA Middleware TANIMLAMASI

const sagaMiddleware = createSagaMiddleware();

//PERSIST TANIMLAMASI

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducers);
//REDUX STORE TANIMLAMASI
const store = configureStore({
  reducer: persistedReducer,
  middleware: [sagaMiddleware],
});
sagaMiddleware.run(rootSaga);

export default store;

//ROOT STATE, Global state in type ını tanımlamak için kullanıyoruz.
//Return Type typescript üzerinde tip döndüren özellik
export type RootState = ReturnType<typeof store.getState>;

//Hook ları type lı hallerini tanımlıyoruz
//Örneğin;
//const todos=useSelector((state:Type)=> states.todos )
//useAppSelector tip verdiğimizde burada state de tip vermemize gerek kalmayacak zaten tanımlamış olacağız
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>(); //
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector; //
